// extracted by mini-css-extract-plugin
export default {"secondaryButton":"styles_secondaryButton__YXGi3","secondaryButtonText":"styles_secondaryButtonText__4tBwh"};